import {Component, OnInit, HostBinding} from '@angular/core';
import {Title, Meta} from '@angular/platform-browser';
import {AnimationsMetaData} from '../../_animations/animations.metadata';
import {Subscription} from 'rxjs/Subscription';
import {AnimationService} from '../../_animations/animations.service';
import {RouteDirections, IRouteDirection} from '../../_animations/route-directions.constant';

@Component({
  selector: 'app-regus',
  providers: [AnimationService, RouteDirections],
  templateUrl: './regus.component.html',
  styleUrls: ['./regus.component.css'],
  animations: [AnimationsMetaData]
})
export class RegusComponent implements OnInit {
  @HostBinding('@routing') routing;
  @HostBinding('style.display') display = 'block';
  animationServiceEventsSubscription: Subscription;
  public routeDirections: IRouteDirection[];

  constructor(private Title: Title,
              private Meta: Meta,
              private animationService: AnimationService,
              routeDirections: RouteDirections) {
    this.routeDirections = routeDirections.regus;
  }

  ngOnInit() {
    this.Title.setTitle('Results | Regus');
    this.Meta.addTag({name: 'description', content: 'My work on a suite of data management tools for Regus'});
    this.routing = this.animationService.animationDirection();
    this.animationServiceEventsSubscription = this.animationService.emitCurrentDirection
      .subscribe((direction: any) => {
        this.routing = direction;
      });
  }

  go(direction: string, url: string) {
    return this.animationService.routingService(direction, url);
  }
  pan($event, url: string) {
    return this.animationService.mobileRoutingSerivce($event, url);
  }
}



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/results/regus/regus.component.ts